import Vue from 'vue';
import Router from 'vue-router';

// Containers
const TheContainer = () => import('@/containers/TheContainer');

// Dashboard
const Dashboard = () => import('@/views/Dashboard');
// Settings
const FormSettings = () => import('@/views/settings/FormSettings');
// Clients
const Clients = () => import('@/views/clients/Clients');
const Client = () => import('@/views/clients/Client');
const FormClient = () => import('@/views/clients/FormClient');
const FollowUpClients = () => import('@/views/clients/FollowUpClients');
// Orders
const Orders = () => import('@/views/orders/Orders');
const Order = () => import('@/views/orders/Order');
const FormOrder = () => import ('@/views/orders/FormOrder');
const OrderHistory = () => import('@/views/orders/OrderHistory');
// Employees
const Employees = () => import('@/views/employees/Employees');
const Employee = () => import('@/views/employees/Employee');
const FormEmployee = () => import('@/views/employees/FormEmployee');
// Products
const Products = () => import('@/views/products/Products');
const Product = () => import('@/views/products/Product');
const FormProduct = () => import('@/views/products/FormProduct');
// Drivers
const Drivers = () => import('@/views/drivers/Drivers');
const Driver = () => import('@/views/drivers/Driver');
const FormDriver = () => import('@/views/drivers/FormDriver');
// Expenses
const Expenses = () => import('@/views/expenses/Expenses');
const Expense = () => import('@/views/expenses/Expense');
const FormExpense = () => import ('@/views/expenses/FormExpense');
// Expense Types
const ExpenseTypes = () => import('@/views/expenses/ExpenseTypes');
const ExpenseType = () => import('@/views/expenses/ExpenseType');
const FormExpenseType = () => import('@/views/expenses/FormExpenseType');
// Report
const FormReport = () => import('@/views/reports/FormReport')
const Reports = () => import('@/views/reports/Reports')
const Report = () => import('@/views/reports/Report')
//Roles
const Roles = () => import('@/views/roles/Roles');
const Role = () => import('@/views/roles/Role');
const FormRole = () => import('@/views/roles/FormRole');
// Users
const Users = () => import('@/views/users/Users');
const User = () => import('@/views/users/User');
const Profile = () => import('@/views/users/Profile');
const FormUser = () => import('@/views/users/FormUser');

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

//Notes
const Notes = () => import('@/views/notes/Notes')
const Note = () => import('@/views/notes/Note')
const EditNote = () => import('@/views/notes/EditNote')
const CreateNote = () => import('@/views/notes/CreateNote')

//Bread
const Breads = () => import('@/views/bread/Breads')
const Bread = () => import('@/views/bread/Bread')
const EditBread = () => import('@/views/bread/EditBread')
const CreateBread = () => import('@/views/bread/CreateBread')
const DeleteBread = () => import('@/views/bread/DeleteBread')

//Resources
const Resources = () => import('@/views/resources/Resources')
const CreateResource = () => import('@/views/resources/CreateResources')
const Resource = () => import('@/views/resources/Resource')
const EditResource = () => import('@/views/resources/EditResource')
const DeleteResource = () => import('@/views/resources/DeleteResource')

//Email
const Emails        = () => import('@/views/email/Emails')
const CreateEmail   = () => import('@/views/email/CreateEmail')
const EditEmail     = () => import('@/views/email/EditEmail')
const ShowEmail     = () => import('@/views/email/ShowEmail')
const SendEmail     = () => import('@/views/email/SendEmail')

const Menus       = () => import('@/views/menu/MenuIndex')
const CreateMenu  = () => import('@/views/menu/CreateMenu')
const EditMenu    = () => import('@/views/menu/EditMenu')
const DeleteMenu  = () => import('@/views/menu/DeleteMenu')

const MenuElements = () => import('@/views/menuElements/ElementsIndex')
const CreateMenuElement = () => import('@/views/menuElements/CreateMenuElement')
const EditMenuElement = () => import('@/views/menuElements/EditMenuElement')
const ShowMenuElement = () => import('@/views/menuElements/ShowMenuElement')
const DeleteMenuElement = () => import('@/views/menuElements/DeleteMenuElement')

const Media = () => import('@/views/media/Media')


Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'settings',
          name: 'Settings',
          component: FormSettings
        },
        {
          path: 'clients',
          meta: { label: 'Clients'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Clients',
              component: Clients,
            },
            {
              path: 'followup',
              meta: { label: 'Follow Up Clients' },
              name: 'FollowUpClients',
              component: FollowUpClients
            },
            {
              path: 'create',
              meta: { label: 'Add Client' },
              name: 'CreateClient',
              component: FormClient
            },
            {
              path: ':id',
              meta: { label: 'View Client'},
              name: 'Client',
              component: Client,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Client' },
              name: 'EditClient',
              component: FormClient
            }
          ]
        },
        {
          path: 'orders',
          meta: { label: 'Orders' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Orders',
              component: Orders
            },
            {
              path: 'create',
              meta: { label: 'Add Order' },
              name: 'CreateOrder',
              component: FormOrder
            },
            {
              path: ':id/',
              meta: { label: 'View Order' },
              name: 'Order',
              component: Order
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Order' },
              name: 'EditOrder',
              component: FormOrder
            },
          ]
        },
        {
          path: 'employees',
          meta: { label: 'Employees'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: "Employees",
              component: Employees,
            },
            {
              path: 'create',
              meta: { label: 'Add Employee' },
              name: 'CreateEmployee',
              component: FormEmployee
            },
            {
              path: ':id',
              meta: { label: 'View Employee'},
              name: 'Employee',
              component: Employee,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Employee' },
              name: 'EditEmployee',
              component: FormEmployee
            },
          ]
        },
        {
          path: 'drivers',
          meta: { label: 'Drivers'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: "Drivers",
              component: Drivers,
            },
            {
              path: 'create',
              meta: { label: 'Add Driver' },
              name: 'CreateDriver',
              component: FormDriver
            },
            {
              path: ':id',
              meta: { label: 'View Driver'},
              name: 'Driver',
              component: Driver,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Driver' },
              name: 'EditDriver',
              component: FormDriver
            },
          ]
        },
        {
          path: 'reports',
          meta: { label: 'Reports'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'create-report',
              meta: { label: 'Create Report' },
              name: "FormReport",
              component: FormReport
            },
            {
              path: 'reports',
              meta: { label: 'Report List' },
              name: "Reports",
              component: Reports
            },
            {
              path: ':id',
              meta: { label: 'View Report'},
              name: 'Report',
              component: Report,
            },
          ]
        },
        {
          path: 'expenses',
          meta: { label: 'Expenses'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: "Expenses",
              component: Expenses,
            },
            {
              path: 'create',
              meta: { label: 'Add Expense' },
              name: 'CreateExpense',
              component: FormExpense
            },
            {
              path: ':id',
              meta: { label: 'View Expense'},
              name: 'Expense',
              component: Expense,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Expense' },
              name: 'EditExpense',
              component: FormExpense
            },
          ]
        },
        {
          path: 'expense-types',
          meta: { label: 'Expense Types'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: "ExpenseTypes",
              component: ExpenseTypes,
            },
            {
              path: 'create',
              meta: { label: 'Add Expense Type' },
              name: 'CreateExpenseType',
              component: FormExpenseType
            },
            {
              path: ':id',
              meta: { label: 'View Expense Type'},
              name: 'ExpenseType',
              component: ExpenseType,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Expense Type' },
              name: 'EditExpenseType',
              component: FormExpenseType
            },
          ]
        },
        {
          path: 'delivery-types',
          meta: { label: 'Delivery Types' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Products',
              component: Products
            },
            {
              path: 'create',
              meta: { label: 'Add Delivery Type' },
              name: 'CreateProduct',
              component: FormProduct
            },
            {
              path: ':id',
              meta: { label: 'View Delivery Type'},
              name: 'Product',
              component: Product,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Delivery Type' },
              name: 'EditProduct',
              component: FormProduct
            },
          ]
        },
        {
          path: 'delivery-history',
          meta: { label: 'Delivery History' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'OrderHistory',
              component: OrderHistory
            }
          ]
        },
        {
          path: 'media',
          name: 'Media',
          component: Media
        },
        {
          path: 'colors',
          name: 'Colors',
          component: Colors
        },
        {
          path: 'typography',
          name: 'Typography',
          component: Typography
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'menu',
          meta: { label: 'Menu'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Menus,
            },
            {
              path: 'create',
              meta: { label: 'Create Menu' },
              name: 'CreateMenu',
              component: CreateMenu
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Menu' },
              name: 'EditMenu',
              component: EditMenu
            },
            {
              path: ':id/delete',
              meta: { label: 'Delete Menu' },
              name: 'DeleteMenu',
              component: DeleteMenu
            },
          ]
        },
        {
          path: 'menuelement',
          meta: { label: 'MenuElement'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':menu/menuelement',
              component: MenuElements,
            },
            {
              path: ':menu/menuelement/create',
              meta: { label: 'Create Menu Element' },
              name: 'Create Menu Element',
              component: CreateMenuElement
            },
            {
              path: ':menu/menuelement/:id',
              meta: { label: 'Menu Element Details'},
              name: 'Menu Element',
              component: ShowMenuElement,
            },
            {
              path: ':menu/menuelement/:id/edit',
              meta: { label: 'Edit Menu Element' },
              name: 'Edit Menu Element',
              component: EditMenuElement
            },
            {
              path: ':menu/menuelement/:id/delete',
              meta: { label: 'Delete Menu Element' },
              name: 'Delete Menu Element',
              component: DeleteMenuElement
            },
          ]
        },
        {
          path: 'notes',
          meta: { label: 'Notes'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Notes,
            },
            {
              path: 'create',
              meta: { label: 'Create Note' },
              name: 'Create Note',
              component: CreateNote
            },
            {
              path: ':id',
              meta: { label: 'Note Details'},
              name: 'Note',
              component: Note,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Note' },
              name: 'Edit Note',
              component: EditNote
            },
          ]
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users,
            },
            {
              path: 'create',
              meta: { label: 'Create User' },
              name: 'CreateUser',
              component: FormUser
            },
            {
              path: ':id',
              meta: { label: 'User Details'},
              name: 'User',
              component: User,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit User' },
              name: 'EditUser',
              component: FormUser
            },
            {
              path: 'profile/:id',
              meta: { label: 'Profile' },
              name: 'Profile',
              component: Profile
            }
          ]
        },
        {
          path: 'roles',
          meta: { label: 'Roles'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Roles',
              component: Roles,
            },
            {
              path: 'create',
              meta: { label: 'Create Role' },
              name: 'CreateRole',
              component: FormRole
            },
            {
              path: ':id',
              meta: { label: 'Role Details'},
              name: 'Role',
              component: Role,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Role' },
              name: 'EditRole',
              component: FormRole
            },
          ]
        },
        {
          path: 'bread',
          meta: { label: 'Bread'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Breads,
            },
            {
              path: 'create',
              meta: { label: 'Create Bread' },
              name: 'CreateBread',
              component: CreateBread
            },
            {
              path: ':id',
              meta: { label: 'Bread Details'},
              name: 'Bread',
              component: Bread,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Bread' },
              name: 'Edit Bread',
              component: EditBread
            },
            {
              path: ':id/delete',
              meta: { label: 'Delete Bread' },
              name: 'Delete Bread',
              component: DeleteBread
            },
          ]
        },
        {
          path: 'email',
          meta: { label: 'Emails'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Emails,
            },
            {
              path: 'create',
              meta: { label: 'Create Email Template' },
              name: 'Create Email Template',
              component: CreateEmail
            },
            {
              path: ':id',
              meta: { label: 'Show Email Template'},
              name: 'Show Email Tempalte',
              component: ShowEmail,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Email Tempalate' },
              name: 'Edit Email Template',
              component: EditEmail
            },
            {
              path: ':id/sendEmail',
              meta: { label: 'Send Email' },
              name: 'Send Email',
              component: SendEmail
            },
          ]
        },
        {
          path: 'resource',
          meta: { label: 'Resources'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':bread/resource',
              component: Resources,
            },
            {
              path: ':bread/resource/create',
              meta: { label: 'Create Resource' },
              name: 'CreateResource',
              component: CreateResource
            },
            {
              path: ':bread/resource/:id',
              meta: { label: 'Resource Details'},
              name: 'Resource',
              component: Resource,
            },
            {
              path: ':bread/resource/:id/edit',
              meta: { label: 'Edit Resource' },
              name: 'Edit Resource',
              component: EditResource
            },
            {
              path: ':bread/resource/:id/delete',
              meta: { label: 'Delete Resource' },
              name: 'Delete Resource',
              component: DeleteResource
            },
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumb',
              name: 'Breadcrumb',
              component: Breadcrumbs
            },
            {
              path: 'carousel',
              name: 'Carousel',
              component: Carousels
            },
            {
              path: 'collapse',
              name: 'Collapse',
              component: Collapses
            },
            {
              path: 'jumbotron',
              name: 'Jumbotron',
              component: Jumbotrons
            },
            {
              path: 'list-group',
              name: 'List Group',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'pagination',
              name: 'Pagination',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress',
              name: 'Progress',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-group',
              name: 'Button Group',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icon',
          redirect: '/icons/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'Icons library',
              component: CoreUIIcons
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badge',
              name: 'Badge',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ],
      beforeEnter: (to, from, next) => {
        let token = localStorage.getItem("api_token");
        if (!token) {
          next('/login');
          return 0;
        }

        const publicPages = ['/login'];
        const authRequired = !publicPages.includes(to.path);

        const base64Url = token.split(".")[1];
        const base64Info = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        token = JSON.parse(window.atob(base64Info));
        // // const tokenExp = token.exp;
        const now = ~~(Date.now() / 1000); // ~~ faster equivalent of Math.floor()

        const tokenExpired = token.exp <= now;

        // console.log(authRequired, tokenExpired);

        if (authRequired && tokenExpired) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
      ]
    },
    {
      path: '/',
      redirect: '/login',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404
    }
  ]
}
